import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-modal" }
const _hoisted_2 = { class: "n-modal__modal" }
const _hoisted_3 = { class: "n-modal__header" }
const _hoisted_4 = { class: "n-modal__body" }
const _hoisted_5 = { class: "n-modal__footer" }


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-modal',
},
  __name: 'modal',
  emits: ["cancel"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "n-modal__background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel'))),
          class: "n-modal__close-button",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        _renderSlot(_ctx.$slots, "body")
      ]),
      _createElementVNode("footer", _hoisted_5, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ])
  ]))
}
}

})